import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "media",
  class: "section-container"
}
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = { class: "image-wrap" }
const _hoisted_4 = { class: "image-wrap" }
const _hoisted_5 = { class: "image-wrap" }
const _hoisted_6 = { class: "image-wrap" }
const _hoisted_7 = { class: "video-wrap" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { vReveal } from '@/directives/reveal'
import VideoPlayer from './VideoPlayer.vue'
import ImagePreview from './ImagePreview.vue'
import fig1Src from '@/assets/picture/New Fig1 overview v10152025_page.jpg'
import fig2Src from '@/assets/picture/New Fig2 LSV benchmark_page.jpg'
import fig3Src from '@/assets/picture/New Fig3 XR-AI_page.jpg'
import fig4Src from '@/assets/picture/New Fig4 demo v10152025_page.jpg'
import videoPoster from '@/assets/picture/JasonHuang_first_frame.png'

// 视频文件放在 public 目录，直接使用路径引用
const videoSrc = '/videos/Media_No2_NVIDIA_GTC_2025Oct_JensenHuang_Keynote.mov'


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaSection',
  setup(__props) {

const router = useRouter()

onMounted(() => {
  if (router.currentRoute.value.hash === '#media') {
    document.getElementById('media')?.scrollIntoView({ behavior: 'smooth' })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "section-title" }, "Media", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "section-lead" }, " Key figures and short demo clips from the paper to make LabOS more intuitive at a glance. ", -1)),
      _createVNode(_component_a_row, {
        gutter: [18, 18],
        style: {"margin-bottom":"22px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "media-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(ImagePreview, {
                      src: _unref(fig1Src),
                      alt: "Figure 1: LabOS overview with agentic dry-lab and XR wet-lab modules"
                    }, null, 8, ["src"])
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "caption" }, " Fig. 1 — LabOS overview: multi‑agent dry‑lab (planning, development, critic, tool‑creation) and XR‑mediated wet‑lab collaboration. ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "media-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(ImagePreview, {
                      src: _unref(fig2Src),
                      alt: "Figure 2: LSV benchmark and LabOS‑VLM results"
                    }, null, 8, ["src"])
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "caption" }, " Fig. 2 — LabSuperVision (LSV) benchmark & LabOS‑VLM family performance on protocol alignment and error detection. ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "media-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(ImagePreview, {
                      src: _unref(fig3Src),
                      alt: "Figure 3: XR streaming and 3D/4D reconstruction for live guidance"
                    }, null, 8, ["src"])
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "caption" }, " Fig. 3 — XR streaming, live guidance, deviation prompts, and 3D/4D reconstruction (Gaussian splatting) for spatial grounding. ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "media-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(ImagePreview, {
                      src: _unref(fig4Src),
                      alt: "Figure 4: Applications across NK target discovery, cell fusion mechanism, and stem cell engineering"
                    }, null, 8, ["src"])
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "caption" }, " Fig. 4 — Applications: NK immunotherapy target discovery (CEACAM6), cell‑fusion regulator (ITSN1), and iPSC experiments copiloted by LabOS. ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "note-text" }, " These figures showcase the key components and applications of the LabOS system, from architecture to real-world biomedical experiments. ", -1)),
      _createVNode(_component_a_row, {
        gutter: [18, 18],
        style: {"margin-bottom":"22px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "media-card video-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(VideoPlayer, {
                      class: "media-video",
                      src: videoSrc,
                      poster: _unref(videoPoster),
                      "cover-scale": 1.7
                    }, null, 8, ["poster"])
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "caption" }, " NVIDIA GTC 2025Oct JensenHuang Keynote ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])), [
      [_unref(vReveal)]
    ])
  ]))
}
}

})